import React from 'react';
import "../css/D-anim.css"
class Loader extends React.Component{
    render() {
        return(
            <div id = "animation" class="shapeshifter play"></div>
        );
    }
}
export default Loader;